import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import agent from '../../agent';
import { DEFAULT_THEME_COLOR } from '../../constants/theme';
import { THE_FREAKS_LINK } from '../../utils/theFreaks';
import useFreaksT from './useFreaksT';
import { FREAKS_GOLD, FREAKS_RED } from './freaksStyles';

// Entry to The Freaks, pinned to the right end of the freaks feed tabs (My / Public / Followed / Daily).
// A red dot shows when today's prize is waiting, so there's a reason to open the game every day.
export const TheFreaksButton = ({ currentUser }) => {
  const { t } = useFreaksT();
  const navigate = useNavigate();
  const [prizeWaiting, setPrizeWaiting] = useState(false);
  const loggedIn = !!currentUser?.username;

  useEffect(() => {
    if (!loggedIn) return undefined;
    let active = true;
    agent.TheFreaks.status()
      .then((status) => active && setPrizeWaiting(!!status.dailyClaimable))
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [loggedIn]);

  if (!loggedIn) return null;

  return (
    <ButtonBase
      data-testid="the-freaks-button"
      onClick={() => navigate(THE_FREAKS_LINK)}
      aria-label={t('theFreaks.homeButtonA11y')}
      sx={{
        display: 'flex', alignItems: 'center', gap: 0.75, border: `1px solid ${DEFAULT_THEME_COLOR}`, borderRadius: 4,
        px: 1.25, minHeight: 36, flexShrink: 0, alignSelf: 'center', mx: 1, color: 'white',
      }}
    >
      <Box sx={{ position: 'relative', display: 'flex' }}>
        <WorkspacePremiumIcon sx={{ fontSize: 18, color: FREAKS_GOLD }}/>
        {prizeWaiting ? (
          <Box
            data-testid="the-freaks-button-dot"
            sx={{
              position: 'absolute', top: -3, right: -4, width: 9, height: 9, borderRadius: '50%',
              backgroundColor: FREAKS_RED, border: '1px solid black',
            }}
          />
        ) : null}
      </Box>
      <Typography sx={{ fontWeight: 700, fontSize: 14, display: { xs: 'none', sm: 'block' } }}>{t('theFreaks.homeButton')}</Typography>
    </ButtonBase>
  );
};

const mapStateToProps = (state) => ({ currentUser: state.common.currentUser });

export default connect(mapStateToProps)(TheFreaksButton);
